import { ManageUnitsUnitView } from '@mark43/cad-api';

export function createUnitSortComparator(primaryUnitId: number | undefined) {
    return (a: ManageUnitsUnitView, b: ManageUnitsUnitView) => {
        return a.id === primaryUnitId
            ? -1
            : b.id === primaryUnitId
            ? 1
            : a.sortKey.localeCompare(b.sortKey);
    };
}
